import request from "@/utils/api/helpers";

const baseUrl = "/profile";

// eslint-disable-next-line import/prefer-default-export
export const getUser = () => request({
  url: `${baseUrl}/me`,
});
